export const basicHome = {
  security: "armor",
  guest_ssid: "guest1-1",
  guest_pwd: "guest2-1",
  armor_stat: "Armor-condition",
};

export default basicHome;
